export const USER_INIT = 'USER_INIT'
export const SENT_RASA_LOGIN_COOKIES = 'SENT_RASA_LOGIN_COOKIES'
export const DISCONNECTED = 'disconnected'